<template>
  <div id="mtw-app">
    <div class="mtw-grid" :class="direction === 'horizontal' ? 'horizontal-list' : 'vertical-list'">
      <div v-for="item in tourList" :key="item.tour_name" class="mtw-grid-item">
        <div class="mtw-card">
          <a :href="typeof item.package_id !== 'undefined' ? `${item.url}?referent_id=${item.merchant_ref_name}&utm_source=Widget&utm_medium=Widget&utm_campaign=Widget` : `https://italy.mytour.eu/${language}/details/${item.url}?referent_id=${item.merchant_ref_name}&utm_source=Widget&utm_medium=Widget&utm_campaign=Widget`"
             :alt="item.tour_name" :title="item.tour_name"
             @click="addClickStatistics(item)"
             target="_blank"
             class="link">
            <img
              class="card-img"
              :src="item.image"
              :alt="item.tour_name" :title="item.tour_name"
            />
            <span class="category">{{ item.category }}</span>
            <span class="price">{{ item.price }} €</span>
            <div class="card-content">
              <h1 class="card-header">{{ item.tour_name }}</h1>
              <p class="card-text">
                {{ item.description }}
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      tourUrl: '',
      tourList: [],
      direction: this.$route.query.direction,
      ref_no: this.$route.query.ref_no,
      code: this.$route.query.code,
      language: typeof this.$route.query.lang === 'undefined' ? 'en' : this.$route.query.lang,
      referrer: document.referrer,
      totalClick: 0,
      token: '',
    };
  },
  methods: {
    generateAuthString() {
      this.token = btoa(`${this.ref_no}#${this.code}#${this.language}`);
    },
    updateUsingOption() {
      const url = 'https://api.mytour.eu/api/v1/widget/using/status';
      const options = {
        headers: {
          'Content-type': 'application/json',
          Authorization: this.token,
        },
      };
      const data = {
        reference_no: this.ref_no,
        url: this.referrer,
      };

      this.axios.post(url, data, options)
        .then(() => {});
    },
    addClickStatistics(item) {
      const url = 'https://api.mytour.eu/api/v1/widget/tour/click';
      const options = {
        headers: {
          'Content-type': 'application/json',
          Authorization: this.token,
        },
      };
      const data = {
        reference_no: this.ref_no,
        tour_id: item.tour_id,
        tour_name: item.tour_name,
      };

      this.axios.post(url, data, options)
        .then(() => {
          this.totalClick += 1;
        });
    },
    getTours() {
      const url = 'https://api.mytour.eu/api/v1/widget/tours';
      const options = {
        headers: {
          'Content-type': 'application/json',
          Authorization: this.token,
        },
      };

      this.axios.get(url, options)
        .then((res) => {
          this.tourList = res.data.data;
        });
    },
  },
  created() {
    this.generateAuthString();
    this.getTours();
    this.updateUsingOption();
  },
};
</script>
<style>
  #mtw-app {
    box-sizing: border-box;
    font-size: 55%;
    display: flex;
    justify-content: center;
    align-content: center;
    padding: 6rem;
    font-family: 'Inter', sans-serif;
  }
  @media (max-width: 60em) {
    #mtw-app {
      padding: 1.5rem;
    }
  }
  .mtw-grid {
    display: grid;
    width: 114rem;
    grid-gap: 4rem;
    grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
    align-items: start;
  }
  @media (max-width: 60em) {
    .mtw-grid {
      grid-gap: 3rem;
    }
  }
  .mtw-card {
    position: relative;
  }
  .mtw-grid-item {
    background-color: #fff;
    border-radius: 0.4rem;
    overflow: hidden;
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.08);
    cursor: pointer;
    transition: 0.2s;
    height: 100%;
  }
  .mtw-grid-item:hover {
    transform: translateY(-0.5%);
    box-shadow: 0 2rem 4rem rgba(0, 0, 0, 0.1);
  }
  .vertical-list.mtw-grid {
    display: grid;
    width: 100%;
  }
  .mtw-grid-item:hover {
    transform: translateY(-0.5%);
    box-shadow: 0 2rem 4rem rgba(0, 0, 0, 0.1);
  }
  .mtw-card .card-img {
    display: block;
    width: 100%;
    height: 15rem;
    object-fit: cover;
  }
  .mtw-card .price {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #41b883;
    color: #fff;
    padding: .25em .4em;
    text-align: center;
    border-radius: .25rem;
    font-size: 13px;
  }
  .mtw-card .category {
    position: absolute;
    top: 10px;
    left: 10px;
    background: #595c97;
    color: #fff;
    padding: .25em .4em;
    text-align: center;
    border-radius: .25rem;
    max-width: 50%;
    font-size: 13px;
  }
  .mtw-card .card-content {
    padding: 15px;
  }
  .mtw-card .card-header {
    font-size: 20px;
    font-weight: bold;
    color: #141322;
    margin-bottom: 1.5rem;
    text-decoration: none !important;
  }
  .mtw-card .card-text {
    font-size: 14px;
    line-height: 1.4;
    color: #595c97;
    margin-bottom: 2.5rem;
    text-decoration: none !important;
  }
  .mtw-grid a {
    text-decoration: none !important;
  }
</style>
